import { render, staticRenderFns } from "./ModalTextLinkExtension.vue?vue&type=template&id=ce37996a&scoped=true&"
import script from "./ModalTextLinkExtension.vue?vue&type=script&lang=ts&"
export * from "./ModalTextLinkExtension.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTextLinkExtension.vue?vue&type=style&index=0&id=ce37996a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce37996a",
  null
  
)

export default component.exports